const getLocalSettleAfterBill = () => {
  const val = localStorage.getItem("settleAfterBill");
  return val === null ? false : val === "true";
};
export default getLocalSettleAfterBill;
